import { useQuery } from '@tanstack/react-query';

import { apiFetch } from '@/lib/api/client';

/** 승인된 휴일근무 한 건(V446). 대체휴무는 이것을 골라 쓴다. */
export type HolidayWork = {
  id: string;
  workDate: string;
  /** 법정공휴일이면 그 이름. 일요일이면 null. */
  holidayName: string | null;
  days: number;
  used: number;
  /** 오늘 쓸 수 있는 남은 일수. 기한이 지났으면 0. */
  remaining: number;
  /** 근무한 달의 다음 달 말일. */
  expiresOn: string;
  status: '사용 가능' | '사용 완료' | '소멸';
};

/**
 * 내 휴일근무. 대체휴무 신청서는 고쳐 다시 올리는 문서의 id 를 넘겨, 그 문서가 쓴 몫을 남은 일수로 돌려 받는다.
 */
export function useHolidayWorks(exceptDocumentId?: string | null) {
  return useQuery({
    queryKey: ['mypage', 'holiday-works', exceptDocumentId ?? null],
    queryFn: () =>
      apiFetch<HolidayWork[]>(
        '/v1/mypage/holiday-works' + (exceptDocumentId ? `?exceptDocumentId=${exceptDocumentId}` : ''),
      ),
  });
}

/** 「10/19(일)」 처럼 고르는 줄의 날짜. */
export function holidayWorkLabel(work: HolidayWork): string {
  const date = new Date(`${work.workDate}T00:00:00`);
  const day = '일월화수목금토'[date.getDay()];
  return `${date.getMonth() + 1}/${date.getDate()}(${day})${work.holidayName ? ` ${work.holidayName}` : ''}`;
}

/** 평일 시간외근무와 연차 전환(V450). 8시간마다 연차 1일로 바꿀 수 있다. */
export type OvertimeSummary = {
  /** 승인된 시간외근무. `used` 는 연차 전환에 쓰인 시간(결재 중 포함). */
  hours: Array<{ id: string; workDate: string; hours: number; documentId: string | null; used: number }>;
  conversions: Array<{ id: string; days: number; hours: number; documentId: string; status: string }>;
  totalHours: number;
  convertedHours: number;
  availableHours: number;
  convertibleDays: number;
};

/** @param exceptDocumentId 고쳐 다시 올리는 연차 전환 문서 — 그 문서가 쓴 시간을 남은 시간으로 돌려 받는다. */
export function useMyOvertime(exceptDocumentId?: string | null) {
  return useQuery({
    queryKey: ['mypage', 'overtime', exceptDocumentId ?? null],
    queryFn: () =>
      apiFetch<OvertimeSummary>('/v1/mypage/overtime' + (exceptDocumentId ? `?exceptDocumentId=${exceptDocumentId}` : '')),
  });
}
